import { defineMessages } from "react-intl";

export const messages = defineMessages({
  currentMonth: {
    id: "ari.management.currentMonth",
    defaultMessage: "Current month"
  },
  nextMonth: {
    id: "ari.management.nextMonth",
    defaultMessage: "Next month"
  }
});